import { strToElement } from "../frontendlib/dom_utils";

class AudioToggleIcon {
  constructor() {
    this.el = strToElement(`
      <div class="audio-toggle-icon"
          style="margin:10px;border-radius:25px;background-color:black;line-height:10px">
        <svg fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          width="30" height="30" viewBox="0 0 16 16"
        >
          <g class="audio-toggle-unmute" transform="translate(8 8) scale(0.69 0.69) translate(-8 -8)">
            <polygon points="
              14.293,14.293 1.707,1.707 1,2.414 4.586,6 4,6 4,10 7,10 11,14 11,12.414 13.586,15
            "></polygon>
            <polygon points="11,2 7.207,5.793 11,9.586"></polygon>
          </g>
          <g class="audio-toggle-mute" transform="translate(8 8) scale(0.69 0.69) translate(-8 -8)">
            <polygon points="7,6 4,6 4,10 7,10 11,14 11,2"></polygon>
          </g>
        </svg>
      </div>
    `);

    this.setMuted(true);
  }

  getElement() {
    return this.el;
  }

  setMuted(muted) {
    this.el.querySelector(".audio-toggle-unmute").style.display = muted
      ? ""
      : "none";
    this.el.querySelector(".audio-toggle-mute").style.display = muted
      ? "none"
      : "";
  }
}

export default AudioToggleIcon;



// WEBPACK FOOTER //
// ./src/js/lib/audio_toggle_icon.js